import { SubscriptionIntervalTypes } from '../../utils/constants';

export const platform = 'web';

export const SubscriptionTerms = {
    ANNUAL: 'annual',
    MONTHLY: 'monthly',
};

export const intervalToBillingCycle = {
    [SubscriptionIntervalTypes.YEAR]: SubscriptionTerms.ANNUAL,
    [SubscriptionIntervalTypes.MONTH]: SubscriptionTerms.MONTHLY,
};

export const SubscriptionTypes = {
    POWER: 'power',
    FREE: 'free',
};

export const ProfileTypes = {
    SELF: 'self',
    OTHER: 'other',
};

export const ThirdPartyProviders = {
    GLOBAL_PRIVILEGES: 'Global Privileges',
};

export const ThirdPartyTiers = {
    PREMIUM: 'Premium',
};

export const SubscriptionGateways = {
    STRIPE: 'Stripe',
    APPLE: 'Apple',
};

export const UpgradeFunnelEvents = {
    CTA_CLICKED: 'upgrade_cta_clicked',
    CHANGE_CARD_CLICKED: 'change_card_clicked',
    UPGRADE_FAILED: 'upgrade_failed',
};

export const UpgradeFailureTypes = {
    CARD_DECLINED: 'card_declined',
    INSUFFICIENT_FUNDS: 'insufficient_funds',
    PROCESSING_ERROR: 'processing_error',
    UNKNOWN: 'unknown',
};

export const PowerFunnelEvents = {
    POWER_PAYWALL_VIEWED: 'power_paywall_viewed',
    POWER_CHECKOUT_STARTED: 'power_checkout_started',
    POWER_PURCHASE_SUCCEEDED: 'power_purchase_succeeded',
    POWER_UPGRADE_FLOW_ABANDONED: 'power_upgrade_flow_abandoned',
};

export const PowerFunnelUserStatuses = {
    FREE: 'free',
    MONTHLY: 'monthly',
    POWER_PAST_DUE: 'power_past_due',
};

// Numeric provider IDs from memberThirdPartyPlans[].providerId — key off these,
// not the display label (which can change). Source of truth: backend.
export const ThirdPartyProviderIds = {
    GLOBAL_PRIVILEGES: 1,
    FABLETICS: 2,
};

export const PowerFunnelSurfaces = {
    COLLEGE_COACH_VIEW: 'web_college_coach_view',
    COLLEGE_CORNER: 'web_college_corner',
    COLLEGE_SEARCH_PAGE: 'web_college_search_page',
    EVENT_GP_FIND_ACCOMMODATIONS: 'web_event_profile_find_accommodations',
    EVENT_GP_FIND_ACCOMMODATIONS_REGISTRATION_CONFIRMATION: 'web_event_profile_find_accommodations_registration_confirmation',
    EVENT_PROFILE_UPGRADE: 'web_event_profile_upgrade',
    EVENT_REGISTRATION: 'web_event_registration',
    HEADER: 'web_header',
    HOME: 'web_home',
    LOCAL_LEADERBOARD: 'web_player_local_leaderboard',
    LOCAL_RANKINGS: 'web_player_local_ranking',
    MENU: 'web_menu',
    PLAYER_PROFILE: 'web_player_profile',
    PLAYER_PROFILE_COLLEGE_PROSPECT: 'web_player_profile_college_prospect',
    PLAYER_SEARCH_PAGE: 'web_player_search_page',
    POWER_PERKS_PAGE: 'web_perks_page',
    SEARCH_FOOTER: 'web_search_footer',
    SUBSCRIPTION_SETTINGS: 'web_subscription_settings',
    UNKNOWN: 'web_unknown',
};

export const PowerFunnelGatedFeatures = {
    ANNUAL_POWER_DIVISION: 'web_annual_power_division',
    COLLEGE_COACH_VIEWS: 'web_college_coach_views',
    COLLEGE_CORNER_CONFERENCES_FILTER: 'web_college_corner_conferences_filter',
    COLLEGE_CORNER_DIVISIONS_FILTER: 'web_college_corner_divisions_filter',
    COLLEGE_CORNER_MORE_FILTER: 'web_mobile_college_corner_more_filter',
    COLLEGE_CORNER_NATIONALITIES_FILTER: 'web_college_corner_nationalities_filter',
    COLLEGE_CORNER_SEARCH_RESULTS: 'web_college_corner_search_results',
    COLLEGE_CORNER_SNAPSHOT_DATE_FILTER: 'web_college_corner_snapshot_date_filter',
    COLLEGE_CORNER_FIT_TOOL_FILTER: 'web_college_corner_fit_tool_filter',
    EVENT_REGISTRATION: 'web_event_registration',
    FABLETICS: 'web_fabletics_benefit',
    GLOBAL_PRIVILEGES: 'web_global_privileges_benefit',
    HOW_POWER_WORKS: 'web_how_power_works',
    LEADERBOARD: 'web_player_local_leaderboard',
    LOCALIZED_RANKINGS: 'web_player_local_rankings',
    PLAYER_METRICS: 'web_player_metrics',
    PLAYER_COLLEGES_FILTER: 'web_player_colleges_filter',
    PLAYER_MORE_MOBILE_FILTER: 'web_player_more_mobile_filter',
    COLLEGE_PROSPECT_TARGET_LIST: 'web_college_prospect_target_list',
    POWER_PERKS_BANNER: 'web_power_perks_banner',
    POWER_PERKS_CARD: 'web_power_perks_card',
    POWER_PERKS_FOOTER: 'web_power_perks_footer',
    REFERRAL_CODE_POPUP: 'web_referral_code_popup',
    SEARCH_RESULTS: 'web_search_results',
};

export const HotelPlannerTracking = {
    FIND_ACCOMMODATIONS_SURFACE: 'find_accommodations',
    NOT_READY_FOR_POWER_POPUP_SURFACE: 'not_ready_for_power_popup',
    HOTEL_PLANNER_SEARCH_CLICK: 'gp_clicked_go_to_hotel_planner',
    EVENT_LOCATION_MODULE_IMPRESSION: 'hp_event_location_module_impression',
};

export const HotelPlannerCustomSurfaceParam = {
    [PowerFunnelSurfaces.EVENT_GP_FIND_ACCOMMODATIONS]: 'EventOverview',
    [PowerFunnelSurfaces.EVENT_GP_FIND_ACCOMMODATIONS_REGISTRATION_CONFIRMATION]: 'RegistrationConfirmation',
};

export const LeaderboardTrackingData = {
    TITLE: 'view_leaderboard_modal',
    TOP_ONE_HUNDRED_TYPE: 'topOneHundred',
    CLOSE_IN_RANK_TYPE: 'relative',
    LOCALIZED_RANKINGS_FEATURE: 'player local rankings',
    LEADERBOARD_FEATURE: 'player leaderboard',
};
